module.exports = __webpack_public_path__ + "images/d68264b131d28b3f8887ac462452751b-lock_illustration_green.svg";